// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3YaWH","footer":"ModalError_footer__rGyVH"};